import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { NgxSelectModule } from 'ngx-select-ex';
import {PaginationGadgetComponent} from './pagination-gadget.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSelectModule,
    NgxSelectModule
  ],
  declarations: [PaginationGadgetComponent],
  providers: [],
  exports: [PaginationGadgetComponent]
})

export class PaginationGadgetModule {

}
